import { createActions, createReducer } from 'reduxsauce'

import ConsultaServidoresEmTeletrabalhoService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaServidoresEmTeletrabalhoInicio: [],
    buscaConsultaServidoresEmTeletrabalhoErro: ['erro'],
    buscaConsultaServidoresEmTeletrabalhoSucesso: ['consultaServidoresEmTeletrabalho'],
    limpar: [],
    setConsultaServidoresEmTeletrabalhoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaServidoresEmTeletrabalho = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaServidoresEmTeletrabalhoInicio())
        let serv = new ConsultaServidoresEmTeletrabalhoService()
        return serv
            .consultarServidoresEmTeletrabalho(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaServidoresEmTeletrabalhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaServidoresEmTeletrabalhoErro(error)))
    }
}

const buscaConsultaServidoresEmTeletrabalhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaServidoresEmTeletrabalhoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaServidoresEmTeletrabalhoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaServidoresEmTeletrabalho.resultado,
        dataSincronizacaoDados: action.consultaServidoresEmTeletrabalho.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaServidoresEmTeletrabalho.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaServidoresEmTeletrabalhoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_SERVIDORES_EM_TELETRABALHO_INICIO]: buscaConsultaServidoresEmTeletrabalhoInicio,
    [Types.BUSCA_CONSULTA_SERVIDORES_EM_TELETRABALHO_ERRO]: buscaConsultaServidoresEmTeletrabalhoErro,
    [Types.BUSCA_CONSULTA_SERVIDORES_EM_TELETRABALHO_SUCESSO]: buscaConsultaServidoresEmTeletrabalhoSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_SERVIDORES_EM_TELETRABALHO_ESTADO_DT]: setConsultaServidoresEmTeletrabalhoEstadoDT,
})
